import { UserService } from './../../../users/user.service';
import { NgClass } from '@angular/common';
import { Component, forwardRef, inject, input, Input, OnDestroy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { TrimDirective } from '../../directives/trim.directive';

@Component({
  selector: 'app-input',
  standalone: true,
  imports: [TranslateModule, NgClass, TrimDirective],
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputComponent),
      multi: true
    }
  ]
})
export class InputComponent implements ControlValueAccessor, Validator, OnDestroy {
  label = input<string>('')
  type = input<string>('text')
  placeholder = input<string>('')
  isDisabled = input<boolean>(false)
  isRequired = input<boolean>(false)
  patternErrorMessage = input<string>('input.invalidFormat')
  passwordMismatchMessage = input<string>('Password Mismatch')
  control: AbstractControl | null = null;
  isArabic: boolean = true;
  value: string = '';
  userService = inject(UserService);
  translateService = inject(TranslateService);
  subscriptions = new Subscription();
  constructor() {
    this.isArabic = this.translateService.getDefaultLang() == 'en' ? false : true;
    this.subscriptions.add(this.translateService.onDefaultLangChange.subscribe((res) => {
      if (res) {
        this.isArabic = res.lang == 'en' ? false : true;
      }
    }));
  }
  onChange = (value: string) => { };
  onTouched = () => { };
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.value = input.value;
     this.onChange(this.value);
  }

  writeValue(value: string): void {
    this.value = value;
    this.validate(this.control!);
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled() //  = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;
    return null; // Validators are defined in the parent form group.
  }
}
